import {
	disableBodyScroll,
	enableBodyScroll,
	clearAllBodyScrollLocks,
} from "body-scroll-lock";
const menu = document.querySelector(".mobile-nav__menu");
const mobileNav = document.querySelector(".mobile-nav");
// let heightW;
// const mobileNav = $('.mobile-nav');
let positionScroll;

// $(window).on('load scroll resize', function() {
// 	heightW = window.innerHeight;
//
// });

$(".js-menu").on("click", () => {
	$("body").toggleClass("menu-on");

	if ($("body").hasClass("menu-on")) {
		$("body").addClass("overflow-hidden");
		$("body").addClass("ios-scroll-lock");
		disableBodyScroll(document.body, {
			reserveScrollBarGap: true,
			allowTouchMove: (el) => {
				return (
					el.closest(".mobile-nav__menu") !== null ||
					el.closest(".js-modal.new-discuss-modal") !== null
				);
			},
		});
	} else {
		$("body").removeClass("overflow-hidden");
		$("body").removeClass("ios-scroll-lock");
		enableBodyScroll(document.body);
		$("body, html").animate({ scrollTop: positionScroll }, 0);
	}
});

$(".js-openModalButton").on("click", () => {
	clearAllBodyScrollLocks();
	const modal = document.querySelector(".popup.js-modal.new-discuss-modal");

	setTimeout(() => {
		if (modal.classList.contains("popup--visible")) {
			$("body").addClass("overflow-hidden");
			$("body").addClass("ios-scroll-lock");
			disableBodyScroll(document.body, {
				reserveScrollBarGap: true,
				allowTouchMove: (el) => {
					return el.closest(".js-modal.new-discuss-modal") !== null;
				},
			});
		} else {
			$(".mobile-nav").removeClass("overflow-hidden");
			$("body").removeClass("overflow-hidden");
			$("body").removeClass("ios-scroll-lock");
			enableBodyScroll(document.body);
		}
	}, 50);
});

$(document).on("click", ".js-closeModalButton", () => {
	$(".mobile-nav").removeClass("overflow-hidden");
	enableBodyScroll(document.body);
});
